import {Inject, Pipe, PipeTransform} from '@angular/core';
import moment from 'moment-jalaali';
import {ApiService} from '../services/api.service';

@Pipe({
  name: 'datePipe'
})
export class DatePipe implements PipeTransform {
  gregorianDate: any;
  jalaliDate: any;
  date: any;
  // currentDirection: any;

  constructor(public apiService: ApiService,
  ) {

  }

  // type [true: timestamp, false: dateTime], id: result format
  transform(value: any, type: any, id: any): any {
    if (value) {
      // --------------------------------------------------Jalali--------------------------------------------------------
      if (this.apiService.currentDirection === 'rtl') {
        if (type === 'false') {
          this.gregorianDate = value.split('.')[0];
          this.date = moment(this.gregorianDate).format('ddd,jD jMMM ,jYYYY');
        } else if (type === 'true') {
          this.gregorianDate = moment.unix(value).format('YYYY-MM-DDTHH:mm:ss');
          this.date = moment.unix(value).format('ddd,jD jMMM ,jYYYY');
        }
        this.jalaliDate = moment(this.gregorianDate).format('jYYYY-jM-jD - HH:mm');
        switch (id) {
          case 'd': // DateFormat
            return this.jalaliDate.split(' - ')[0];
          case 't': // Time
            return this.jalaliDate.split(' - ')[1];
          case 'dt': // DateFormat & Time
            return this.jalaliDate;
          case 'fdt':
            const temp = this.date.split(',');
            return (this.selectDay(temp[0]) + ' ' + temp[1] + temp[2]);
          default:
          // code block
        }
      } else {  // --------------------------------------------gregorian---------------------------------------------------

        if (type === 'false') {
          this.gregorianDate = moment(value.split('.')[0]).format('YYYY-MM-DD - HH:mm:ss');
          this.date = moment(value.split('.')[0]).format('ddd,D MMM ,YYYY');
        } else if (type === 'true') {
          this.gregorianDate = moment.unix(value).format('YYYY-MM-DD - HH:mm:ss');
          this.date = moment.unix(value).format('ddd,D MMM ,YYYY');
        }
        switch (id) {
          case 'd': // DateFormat
            return this.gregorianDate.split(' - ')[0];
          case 't': // Time
            return this.gregorianDate.split(' - ')[1];
          case 'dt': // DateFormat & Time
            return this.gregorianDate;
          case 'fdt':
            const temp = this.date.split(',');
            return (temp[0] + ' ' + temp[1] + temp[2]);
          default:
          // code block
        }
      }
    }
  }

  selectDay(dayId) {
    switch (dayId) {
      case 'Sat': {
        return 'شنبه';
        // break;
      }
      case 'Sun': {
        return 'یک شنبه';
        // break;
      }
      case 'Mon': {
        return 'دوشنبه';
        // break;
      }
      case 'Tue': {
        return 'سه شنبه';
        // break;
      }
      case 'Wed': {
        return 'چهارشنبه';
        // break;
      }
      case 'Thu': {
        return 'پنج شنبه';
        // break;
      }
      case 'Fri': {
        return 'جمعه';
        // break;
      }
    }
  }

}
